import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import { authApi } from "./auth/authApi";
import { productsApi } from "./products/productsApi";
import { collectionsApi } from "./collections/collectionsApi";
import { productTypesApi } from "./productTypes/productTypesApi";
import { productImagesApi } from "./productImages/productImagesApi";
import { productVariantsApi } from "./productVariants/productVariantsApi";
import { adminUsersApi } from "./adminUsers/adminUsersApi";
import { ordersApi } from "./orders/ordersApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [collectionsApi.reducerPath]: collectionsApi.reducer,
    [productTypesApi.reducerPath]: productTypesApi.reducer,
    [productImagesApi.reducerPath]: productImagesApi.reducer,
    [productVariantsApi.reducerPath]: productVariantsApi.reducer,
    [adminUsersApi.reducerPath]: adminUsersApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      productsApi.middleware,
      collectionsApi.middleware,
      productTypesApi.middleware,
      productImagesApi.middleware,
      productVariantsApi.middleware,
      adminUsersApi.middleware,
      ordersApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
